import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import { GatsbySanityImageFluidNoBase64 } from '../types';
import { LinkReference } from '../graphql-fragments/LinkReference';
import { getReferenceUrl } from '../utils/utils';
import SlideCarousel from './SlideCarousel';

import * as styles from './SlideSection.module.scss';

interface QueryData {
  sanityHomepage: {
    slides: Array<{
      title: string;
      url: string;
      linkReference: LinkReference;
      backgroundImage: {
        asset: {
          fluid: GatsbySanityImageFluidNoBase64;
        };
      };
    }>;
  };
}

const SlideSection = (): React.ReactElement => {
  const data: QueryData = useStaticQuery(
    graphql`
      {
        sanityHomepage {
          slides {
            title
            url
            linkReference {
              ...LinkReference
            }
            backgroundImage {
              asset {
                fluid(maxWidth: 1920, maxHeight: 640) {
                  ...GatsbySanityImageFluid_noBase64
                }
              }
            }
          }
        }
      }
    `,
  );
  return (
    <section className={styles.container}>
      {data.sanityHomepage?.slides && <SlideCarousel
        slides={data.sanityHomepage.slides.map(slide => ({
          imageFluid: slide.backgroundImage.asset.fluid,
          text: slide.title,
          linkUrl: slide.linkReference
            ? getReferenceUrl(slide.linkReference.__typename, slide.linkReference.slug.current)
            : slide.url,
        }))}
      ></SlideCarousel>}
    </section>
  );
};

export default SlideSection;
